import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsXmppComponent } from './simple-icons-xmpp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsXmppComponent ],
    exports:      [ SimpleIconsXmppComponent ],
    bootstrap:    []
})
export class SimpleIconsXmppModule {}
